export class UpdateIntegrationRequest {
    'config';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "config",
            "baseName": "config",
            "type": "IntegrationConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateIntegrationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
